import { useTranslation } from 'react-i18next'
import { Checkbox, Col, Row } from 'antd'

const ShoppingCartType = ({
  value: propValue = undefined,
  onChange = undefined,
  isDisabled = false,
}) => {
  const { t } = useTranslation()
  const value = propValue ? 'session' : 'user'

  return (
    <Checkbox.Group disabled={isDisabled} value={value}>
      <Row gutter={[12, 12]}>
        <Col>
          <Checkbox value="session" onChange={() => onChange(true)}>
            {t(
              'adminWorkspace.userManagement.userDetails.shoppingCartType.session',
            )}
          </Checkbox>
        </Col>
        <Col>
          <Checkbox value="user" onChange={() => onChange(false)}>
            {t(
              'adminWorkspace.userManagement.userDetails.shoppingCartType.user',
            )}
          </Checkbox>
        </Col>
      </Row>
    </Checkbox.Group>
  )
}

export default ShoppingCartType
